import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { FeatureContext } from '../../../Context';
import { currency, lang, useBfGlobals } from '../../../Utils';
import Loader from '../../../components/loader/Loader';
import { Tooltip } from '@chakra-ui/react';

const KanBanColumn = ({ data }) => <div className={`bf-kanban-column bf-kanban-${data.code.toLowerCase()}`}>
  <KanbanTitle title={data.title} />
  <KanbanSubTitle value={data.totalValue} count={data.count} />
  <KanbanContent code={data.code} items={data.items} onClick={data.onClickItem} />
</div>;

const KanbanTitle = ({ title }) => <div className="bf-kanban-title">
  <span>{title}</span>
</div>

const KanbanSubTitle = ({ value, count }) => <div className="bf-kanban-subtitle">
  <span>{value}</span>
  <label>{count}</label>
</div>

const KanbanContent = ({ code, items, onClick }) => <div className="bf-kanban-content">
  {items?.map((item, index) =>
    <div key={`kb-item-${code}-${index}`} className="bf-kanban-item" onClick={() => onClick(item)}>
      <div className="bf-kanban-text">
        <div className="label">{lang('Material ID')}</div>
        <div className="text">{item.bonfiglioliMaterialNumber}</div>
      </div>
      <div className="bf-kanban-text">
        <div className="label">{lang('Designation')}</div>
        <div className="text">
          <Tooltip label={item.description}>
            {(item.description.length > 40) ? item.description.substring(0, 40) + '*' : item.description}
          </Tooltip>
        </div>
      </div>
      <div className="bf-kanban-info">
        <div>{item.quantity}</div>
        <div>{currency(item.totalNetPrice, item.currency)}</div>
      </div>
    </div>)}
</div>

const Kanban = () => {
  const globals = useBfGlobals();
  const context = useContext(FeatureContext);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const data = (Object.entries(globals.get('orders_status.details')).reduce((acc, status) => {
      const items = context?.details.filter(detail => detail.status.code === status[0]);
      const totalValue = currency(
        items.reduce((total, item) => total += item.totalNetPrice, 0),
        items.slice(1, 0).currency
      );
      const count = items.length;
      acc = {
        ...acc,
        [status[0]]: {
          code: status[0],
          items: items,
          title: lang(status[1]),
          totalValue: totalValue,
          count: count,
          onClickItem : (detail) => context.setDetail(detail)
        }
      }
      return acc;
    }, {}));
    setColumns(data);
  }, []);

  return ((!!columns) ?
    <div 
      className="bf-kanban" 
      style={{gridTemplateColumns : `repeat(${Object.entries(columns).length}, 1fr)`}}>
      {Object.entries(columns).map(column => <KanBanColumn key={`kb-col-${column[0]}`} data={column[1]} />)}
    </div> : <Loader />)
}

export default Kanban;